import PersonalInformationAgreementView from './PersonalInformationAgreementView';
import { AgreementProvider } from '@context/Agreement';

const PersonalInformationAgreement = () => {
  return (
    <AgreementProvider>
      <PersonalInformationAgreementView />
    </AgreementProvider>
  );
};

export default PersonalInformationAgreement;
